import { render, staticRenderFns } from "./QuickOrders.vue?vue&type=template&id=47073bc9"
import script from "./QuickOrders.ts?vue&type=script&lang=ts&external"
export * from "./QuickOrders.ts?vue&type=script&lang=ts&external"
import style0 from "./QuickOrders.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports